// extracted by mini-css-extract-plugin
module.exports = {"pictureLeft":"PictureLeft_pictureLeft__2giU6","doubleContent":"PictureLeft_doubleContent__kJogJ"};